import { socketActionTypes, SOCKET_STATUS } from './socket.types';

const namespaceInitialState = { status: SOCKET_STATUS.IDLE, lastError: null };

const initialState = {
    notifications: { ...namespaceInitialState },
    collaboration: { ...namespaceInitialState },
};

export default function socketReducer(state = initialState, action) {
    switch (action.type) {
        case socketActionTypes.SOCKET_STATUS_CHANGED: {
            const { namespace, status, lastError } = action.payload;
            return {
                ...state,
                [namespace]: { status, lastError: lastError ?? state[namespace].lastError },
            };
        }
        case socketActionTypes.SOCKET_CONNECT_FAILED: {
            const { namespace, error } = action.payload;
            return {
                ...state,
                [namespace]: { status: SOCKET_STATUS.DISCONNECTED, lastError: error },
            };
        }
        default:
            return state;
    }
}
